import { NavItemWithChildren } from '@app/components/layout/sidenav/link/NavItemWithChildren';
import { useDefaultStation } from '@app/core/stations/hooks/useDefaultStation';
import { useIntl } from 'react-intl';
import { ComposeIcon } from '../components/ComposeIcon';

export function useDefaultStationPath(pathWithStation: string) {
  const station = useDefaultStation();

  return pathWithStation.replace('{slug}', station.slug);
}

/**
 * Sidenav entry for Compose: navigates to the compositions list for the default station.
 */
export function ComposeLinks() {
  const { $t } = useIntl();

  return (
    <NavItemWithChildren
      root={useDefaultStationPath('/compose')}
      label={$t({
        id: 'compose.navTitle',
        defaultMessage: 'Compose',
      })}
      icon={<ComposeIcon />}
    />
  );
}
